module.exports = __webpack_public_path__ + "img/gift5.4d663c69.png";